import {
    titleGenerator,
    embeddedStepTextContentGenerator,
    primaryButtonGenerator,
    createBuildingBlocksFromTemplate,
} from '../utils/ai-template-utils';
import { AiBlocks } from '@pendo/services/BuildingBlocks';
import { AI_LAYOUT_TEXT } from '../utils/constants';
import { BuildingBlockLayouts } from '@pendo/services/BuildingBlocks';
import { v4 as uuid } from 'uuid';
import get from 'lodash/get';

const EMBEDED_STEP_TEMPLATE = {
    // right now, the order of the keys matter and dictate the shape the built guide will take
    ARTIFACT_KEYS_TO_GENERATORS: {
        title: titleGenerator,
        stepTextContent: embeddedStepTextContentGenerator,
        buttons: {
            primaryButton: primaryButtonGenerator,
        },
    },
};

export function createGeneratedEmbeddedTemplate ({ theme, generatedSteps, steps }) {
    const newStep = generatedSteps.map((step, index) => {
        return createEmbeddedStepTemplate({
            theme,
            stepArtifact: step,
            stepBlocks: get(steps, `[${index}].buildingBlocks`),
        });
    });

    return AiBlocks.prepStepsForPreview(newStep, steps, theme);
}

export function createEmbeddedStepTemplate ({ theme, stepArtifact, stepBlocks }) {
    const buildingBlocks =
        stepBlocks ||
        BuildingBlockLayouts.createBaseBuildingBlocksForLayout(
            'aiEmbeddedBanner',
            uuid(),
            {}, // empty options
            theme,
        );
    const artifactKeysToGenerators = EMBEDED_STEP_TEMPLATE.ARTIFACT_KEYS_TO_GENERATORS;

    return createBuildingBlocksFromTemplate({
        theme,
        width: 850,
        isEmbeddedGuide: true,
        buildingBlocks,
        stepArtifact,
        artifactKeysToGenerators,
    });
}

export function createArtifactStepFromEmbeddedTemplate () {
    return [
        {
            title: AI_LAYOUT_TEXT.EMBEDDED_TITLE,
            stepTextContent: AI_LAYOUT_TEXT.BODY,
            primaryButton: AI_LAYOUT_TEXT.PRIMARY_CTA,
        },
    ];
}
